<script setup lang="ts">
const props = withDefaults(defineProps<{
  src: string
  alt: string
  width?: number
  height?: number
  loading?: 'lazy' | 'eager'
  srcPlaceholder?: string
  className?: string
}>(), {
  loading: 'lazy',
  srcPlaceholder: '',
  width: undefined,
  height: undefined,
  className: ''
});

const placeholder = ref<HTMLDivElement>();
const small = ref<HTMLImageElement>();

function setImagePlaceholder () {
  placeholder.value!.style.backgroundImage = `url(${small.value!.src})`;
}

function loadSmallImage () {
  const img = new Image();
  img.src = small.value!.src;
  img.onload = function () {
    small.value!.classList.add('loaded');
  };
}

function loadImage () {
  const imgLarge = new Image();
  imgLarge.src = placeholder.value!.dataset.large as string;
  imgLarge.onload = function () {
    imgLarge.classList.add('loaded');
  };
  imgLarge.onerror = function () {
    small.value!.classList.remove('loaded');
  };
  imgLarge.alt = props.alt;
  imgLarge.style.width = '100%';
  imgLarge.style.height = '100%';
  imgLarge.loading = props.loading;
  placeholder.value!.appendChild(imgLarge);
}

onMounted(() => {
  useIntersectionObserver(placeholder, () => {
    setImagePlaceholder();
    loadImage();
    loadSmallImage();
  });
});

</script>

<template>
  <div ref="placeholder" class="placeholder" :data-large="src" :class="className">
    <img
      ref="small"
      :src="srcPlaceholder"
      class="img-small"
      :width="width"
      :height="height"
      :alt="alt"
      :loading="loading"
    >
    <div style="padding-bottom: 100%;" />
  </div>
</template>

<style lang="scss">
.placeholder {
  background-size: cover;
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
  position: relative;
  overflow: hidden;
}

.placeholder img {
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  width: 100%;
  transition: opacity 0.6s linear;
}

.placeholder img.loaded {
  opacity: 1;
}

.img-small {
  filter: blur(50px);
  transform: scale(1);
}
</style>
